import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { FontsService, Font } from '../../../services/fonts.service';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-progressbar',
	templateUrl: './progress-bar.component.html',
	styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('progressBarForm', { static: true }) progressBarForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	progressBarFormSubscription: Subscription;
	circleSizeError = false;
	halfCircleSizeError = false;
	isAdmin;
	font;
	fonts: Array<Font>;
	gradientDefault = '#ff8560';

	constructor(private comService: ComponentService, private fontsService: FontsService, private auth: AuthService) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();

		this.componentData.config.bar_color_gradient = this.componentData.config.bar_color_gradient
			? this.componentData.config.bar_color_gradient
			: this.gradientDefault;
		this.componentData.config.use_gradient = this.componentData.config.use_gradient ? this.componentData.config.use_gradient : false;

		this.fonts = this.fontsService.getFonts();
		this.font =
			this.fontsService.getFontsArray().indexOf(this.componentData.config.text.font) === -1
				? 'Custom Font'
				: this.componentData.config.text.font;

		this.progressBarFormSubscription = this.progressBarForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave(
						(this.progressBarForm.dirty && this.progressBarForm.invalid) || this.nameField.editComponentName
					)
				),
				filter((form) => this.progressBarForm.dirty && this.progressBarForm.valid),
				debounceTime(2000)
			)
			.subscribe((data) => {});
	}

	ngOnDestroy() {
		this.progressBarFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	checkAndVerifySizes(event) {
		if ((event == 'circle' || event == 'halfcircle') && this.componentData.config.circle_size) {
			this.checkCircleSize(this.componentData.config.circle_size, 'circleSize');
		}
	}

	checkCircleSize(event, type) {
		if (this.componentData.config.bar_style == 'circle') {
			this.halfCircleSizeError = false;
			if (type == 'circleSize') {
				this.circleSizeError = !(event <= this.componentData.config.item_width && event <= this.componentData.config.item_height);
			} else {
				this.circleSizeError = !(event >= this.componentData.config.circle_size);
			}
		} else if (this.componentData.config.bar_style == 'halfcircle') {
			this.circleSizeError = false;
			if (type == 'circleSize') {
				this.halfCircleSizeError = !(
					event <= this.componentData.config.item_width && event / 2 <= this.componentData.config.item_height
				);
			} else if (type == 'width') {
				this.halfCircleSizeError = !(event >= this.componentData.config.circle_size);
			} else {
				this.halfCircleSizeError = !(
					event >= this.componentData.config.circle_size / 2 &&
					this.componentData.config.item_width >= this.componentData.config.circle_size
				);
			}
		}
	}
}
